import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5fqs9qr72c: FaireBrandEntity = {
  token: "b_5fqs9qr72c",
  type: "brand",
  name: "Pops Distro Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/af23bebb1a4fc5f00c14ef89c2803426aa8e19e73432925d4c85937dad3fccfb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4cc21c4c5ba951d780cbf3346ca9a0f11448c628aee2909870c3622ae6790e9b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/af23bebb1a4fc5f00c14ef89c2803426aa8e19e73432925d4c85937dad3fccfb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4cc21c4c5ba951d780cbf3346ca9a0f11448c628aee2909870c3622ae6790e9b.jpeg",
  location: "Johnston, RI, USA",
  minimumOrderDollars: 173,
  rating: 4.3,
  reviewCount: 61,
  isInsider: true,
  description:
    "Based in New England, Pops! Distro Inc. is your premier wholesale and retail chain across the USA, specializing in rare and foreign drinks, sodas, and limited edition snacks from around the globe.\n\nJoin us in delighting your customers with the world's most exclusive sodas and snacks. Let’s elevate your offerings to a whole new level of uniqueness and excitement!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.510Z",
    importedBy: "entity-db-cli",
  },
};
